import { getQueryParam, QueryParams } from './routing';

export const isDebugMode = () => {
  return getQueryParam(QueryParams.debugMode) === 'true';
};
